import React, { useState } from "react";
import Link from "gatsby-plugin-transition-link";
import { useStaticQuery, graphql } from "gatsby";
import ModalContact from "../Modal/ModalContact";
import logo from "../../images/Global/Footer/Accel logo desktop.svg";
import equalHousing from "../../images/Global/Footer/equal-housing-lender-1.svg";
import nestLogo from "../../images/Global/Footer/Nest Logo.svg";
import { mapEdgesToNodes } from "../../lib/helpers";

const Footer = ({ hideFooter }) => {
  const getYear = () => {
    return new Date().getFullYear();
  };

  const [statesDropdownOpen, setStatesDropdownOpen] = useState(false);
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);

  // const locationsClickHandler = () => {
  //   setStatesDropdownOpen(!statesDropdownOpen);
  //   setCityDropdownOpen(false);
  // };

  const industriesClickHandler = () => {
    setCityDropdownOpen(!cityDropdownOpen);
    // setStatesDropdownOpen(false);
  };

  const data = useStaticQuery(graphql`
    {
      states: allSanityStates(sort: { fields: [title], order: ASC }) {
        edges {
          node {
            title
            slug {
              current
            }
          }
        }
      }
      cities: allSanityCities(sort: { fields: [title], order: ASC }) {
        edges {
          node {
            title
            slug {
              current
            }
          }
        }
      }
    }
  `);

  // const stateNodes = data && data.states && mapEdgesToNodes(data.states);
  const cityNodes = data && data.cities && mapEdgesToNodes(data.cities);

  const navigation = {
    resources: [
      {
        name: "Our Process",
        href: "/our-process/",
      },
      {
        name: "Calculators",
        href: "/mortgage-calculators/",
      },
      {
        name: "FAQs",
        href: "/faqs/",
      },
      {
        name: "Blog",
        href: "/mortgage-blog/",
      },
    ],
    company: [
      {
        name: "Company",
        href: "/about-us/",
      },
      //   {
      //     name: "Careers",
      //     href: "/mortgage-jobs/",
      //   },
        {
          name: "Reviews",
          href: "/reviews/",
        },
    ],
    apply: [
      {
        name: "Apply Now",
        href: "https://markdarling.floify.com/apply-now",
        outboundLink: true,
      },
      {
        name: "Get Pre-Approved",
        href: "https://markdarling.floify.com/apply-now",
        outboundLink: true,
      },
      {
        name: "Request Rates",
        href: "/request-rates/",
      },
    ],
  };

  return (
    <>
      <footer
        className={`relative z-20 bg-primary-900 pt-20 pb-6 ${
          hideFooter && "hidden"
        }`}
      >
        <div className="container">
          <div className="mb-8 grid space-y-6 lg:mb-16 lg:grid-cols-12 lg:justify-between lg:space-y-0 lg:space-x-16 xl:space-x-24">
            <div className="lg:col-span-3 lg:col-start-1">
              <div>
                <Link to="/">
                  <img
                    src={logo}
                    alt="Accel Mortgage Logo"
                    width={281}
                    className="mb-5 w-[188px] md:w-[281px]"
                  />
                </Link>

                <div className="hidden text-sm font-bold text-white md:block">
                  NMLS #1964528
                  <br />
                  Licensed In: CA
                </div>
              </div>
            </div>
            <div className="mb-10 space-y-8 md:mb-18 md:flex md:justify-between md:space-y-0 md:space-x-6 lg:col-span-9 lg:col-end-13 xl:space-x-10">
              <div>
                <div className="mb-4 font-medium text-white">Resources</div>
                <ul className="flex flex-col space-y-2">
                  {navigation.resources.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <div className="mb-4 font-medium text-white">Company</div>
                <ul className="flex flex-col space-y-2">
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <div className="mb-4 font-medium text-white">Contact</div>

                <ul className="flex flex-col space-y-4 md:space-y-5">
                  <li>
                    <address className="text-sm not-italic">
                      <a
                        href=""
                        target="_blank"
                        rel="noreferrer"
                        className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                      >
                        1070 Hamilton Rd Suite E 
                        <br /> Duarte, CA 91010
                      </a>
                    </address>
                  </li>
                  <li>
                    <a
                      href="tel:323-910-1070"
                      className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                    >
                      (323) 910-1070
                    </a>
                  </li>
                  <li>
                    <a
                      href="mailto:accelmortgagegroup@gmail.com"
                      className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                    >
                      accelmortgagegroup@gmail.com
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <div className="mb-4 font-medium text-white">Get Started</div>
                <ul className="flex flex-col space-y-2">
                  {navigation.apply.map((item) => (
                    <li key={item.name}>
                      {item.outboundLink ? (
                        <a
                          href={item.href}
                          target="_blank"
                          className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                        >
                          {item.name}
                        </a>
                      ) : (
                        <Link
                          to={item.href}
                          className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                        >
                          {item.name}
                        </Link>
                      )}
                    </li>
                  ))}
                  <li>
                    <button
                      data-modal-open="modal-contact"
                      className="whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white"
                    >
                      Contact Us
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mb-6 text-sm font-bold text-white md:hidden">
            NMLS #1964528
            <br />
            Licensed In: CA
          </div>

          <div className="flex flex-col flex-wrap justify-items-center space-y-16 md:flex-row md:flex-nowrap md:items-end md:justify-between md:space-x-4 md:space-y-0">
            <div className="mt-2 w-full text-sm md:mt-0 md:w-auto">
              <img
                src={equalHousing}
                alt="Equal Housing Lender Logo"
                width={59}
              />
            </div>
            <ul className="flex flex-wrap items-center justify-center space-x-4 md:justify-start">
              <li className="font-body text-sm text-white/70">
                © {getYear()} Accel Mortgage
              </li>

              <li className="text-sm">
                <Link
                  to="/privacy-policy/"
                  className="font-body text-sm font-normal text-white/70 no-underline hover:text-white"
                >
                  Privacy Policy
                </Link>
              </li>
              {/* <li className="text-sm">
                <button
                  className="hover:text-primary-500 relative font-normal text-typography-heading/70 no-underline"
                  onClick={locationsClickHandler}
                >
                  <span className="flex items-center justify-between">
                    States
                    <i
                      className={`far fa-chevron-down ml-1 transform text-sm transition-all duration-300 ease-linear ${
                        statesDropdownOpen ? "rotate-180" : "rotate-0"
                      }`}
                    ></i>
                  </span>
                  <ul
                    className={`absolute bottom-0 left-0 flex max-h-28 transform flex-col space-y-1.5 overflow-y-scroll bg-white px-3 pt-4 pb-3 text-left transition-all duration-300 ease-linear md:px-4 md:pb-4 md:pt-5 ${
                      statesDropdownOpen
                        ? "visible -translate-y-8 opacity-100"
                        : "invisible -translate-y-4 opacity-0"
                    }`}
                  >
                    {stateNodes.map((item, i) => (
                      <li className="whitespace-nowrap pb-1.5 text-xs" key={i}>
                        <Link
                          to={`/${item.slug.current}/`}
                          className="hover:text-primary-500 font-body font-normal text-gray-700 no-underline"
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </button>
              </li> */}

              <li className="text-sm">
                <button
                  className="text-primary animation  relative  pl-[.25rem] font-normal text-white/80 no-underline hover:text-white "
                  onClick={industriesClickHandler}
                >
                  <span className="flex items-center justify-between">
                    Cities
                    <i
                      className={`far fa-chevron-down ml-1 transform text-sm transition-all duration-300 ease-linear ${
                        cityDropdownOpen ? "rotate-180" : "rotate-0"
                      }`}
                    ></i>
                  </span>
                  <ul
                    className={`absolute bottom-0 left-0 flex max-h-28 transform flex-col space-y-1.5 overflow-y-scroll bg-white px-3 pt-4 pb-3 text-left transition-all duration-300 ease-linear md:px-4 md:pb-4 md:pt-5 ${
                      cityDropdownOpen
                        ? "visible -translate-y-8 opacity-100"
                        : "invisible -translate-y-4 opacity-0"
                    }`}
                  >
                    {cityNodes.map((item, i) => (
                      <li
                        className="cursor-auto whitespace-nowrap pb-1.5 font-body text-xs text-gray-700"
                        key={i}
                      >
                        {item.slug ? (
                          <Link
                            to={`/${item.slug.current}/`}
                            className="hover:text-primary-500 font-normal text-gray-700 no-underline"
                          >
                            {item.title}
                          </Link>
                        ) : (
                          item.title
                        )}
                      </li>
                    ))}
                  </ul>
                </button>
              </li>
              <li className="w-full md:w-auto">
                <a
                  className="group flex items-center justify-center space-x-1 whitespace-nowrap text-sm font-normal text-white/70 no-underline hover:text-white md:justify-start"
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Powered by</span>
                  <img
                    src={nestLogo}
                    alt="NEST logo"
                    className="opacity-70 transition-opacity duration-300 ease-linear group-hover:opacity-100"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>

      <ModalContact />
    </>
  );
};

export default Footer;
